import React, { Component } from "react";
import { observer } from "mobx-react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { Row, Col } from 'reactstrap';
import InfiniteScroll from "react-infinite-scroll-component";
import LoadingImage from "../../comum/components/LoadingImage";
import Checkbox from '../../comum/components/Checkbox'
import Tooltip from "../../comum/components/Tooltip";
import Card from "./Card";
import {buscaSemResultado} from "../../../utils/mensagens";
import { HeaderTableFixed } from "../../../utils/headerTableFixed";

/*
    Parametros obrigatórios
        listaCompleta // colunas // keyField // marcar //

    Parametros não obrigatórios
        carregando //
*/

@observer
export class TabelaSelecaoMultipla extends Component {

    constructor(props) {
        super(props);

        this.toShow = 10;

        this.state = {
            lista: this.props.listaCompleta,
            items: [],
            turn: 0,
            hasMore: false,
        }

        window.addEventListener('scroll', HeaderTableFixed);
    };

    componentDidMount = () => {
        if (this.state.lista)
            this.loadFirstTurn();
    };

    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.listaCompleta !== this.props.listaCompleta) {
            this.setState({
                lista: this.props.listaCompleta
            })
        }
        if (this.state.lista)
            this.loadFirstTurn();
    };

    handleMarcar = (row) => {
        this.props.marcar(row);
    };

    handleMarcarTodos = (row) => {
        this.props.marcarTodos(row);
    };

    noData = () => {
        
    };

    loadFirstTurn = () => {
        this.state.items = this.state.lista.slice(0, this.toShow);
        this.state.turn = 1;
        this.state.hasMore = this.state.items.length < this.state.lista.length;
    };

    loadNextTurn = () => {
        this.state.items = [];
        this.state.items = this.state.lista.slice(0, (this.state.turn+1)*this.toShow);
        this.state.turn = this.state.turn+1;

        this.state.hasMore = this.state.items.length < this.state.lista.length;
    };

    render() {
        const selectRow = {
            mode: 'checkbox',
            hideSelectAll: !this.props.marcarTodos,
            selectionHeaderRenderer: ({ indeterminate, ...rest }) => (
                <Tooltip tooltipText={`Clique aqui para ${rest.checked || indeterminate ? "desmarcar" : "selecionar"} todos os registros`}>
                    <Checkbox ativo={rest.checked} onClick={() => { }} />
                </Tooltip>
            ),
            selectionRenderer: ({ mode, ...rest }) =>
                <Checkbox ativo={rest.checked} onClick={() => { }} />,
            onSelect: (row, isSelect, rowIndex, e) => {
                e.preventDefault();
                e.stopPropagation();
                this.handleMarcar(row)
            },
            onSelectAll: (isSelect, rows, e) => {
                e.preventDefault();
                e.stopPropagation();
                while (this.state.hasMore) {
                    this.loadNextTurn()
                }

                this.handleMarcarTodos(isSelect);
                if (isSelect) {
                    return this.state.items.map(item => {
                        return item[this.props.keyField]
                    });
                } else {
                    return [];
                }
            },
        };

        return (
            <Card className="card-branco tabela-selecao-multipla">
                { this.props.carregando
                    ? <LoadingImage />
                    : <React.Fragment>
                        { this.state.lista.length<=0
                            ? <Row>
                                <Col xs={12}>
                                    <span className="mensagem-filtrar">
                                        { buscaSemResultado }
                                    </span>
                                </Col>
                            </Row>
                            : <InfiniteScroll
                                dataLength={ this.state.items.length }
                                next={ () => this.loadNextTurn() }
                                hasMore={ this.state.hasMore }
                                loader={ <LoadingImage /> } >

                                <ToolkitProvider
                                    keyField={ this.props.keyField }
                                    data={ [...this.state.items] }
                                    columns={ [...this.props.colunas] } >
                                    { props =>
                                        <div id="tableHeaderFixed" className="tabela-overflow">
                                            <BootstrapTable bootstrap4 striped
                                                bordered={false}
                                                noDataIndication={ () => this.noData() }
                                                classes="tabela tabela-layout"
                                                selectRow={ selectRow }
                                                { ...props.baseProps } 
                                            />
                                        </div>
                                    }
                                </ToolkitProvider>
                            </InfiniteScroll> }
                    </React.Fragment> }

            </Card>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/comum/components/TabelaSelecaoMultipla.js